import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D3251831-8AEF-420A-9AA8-2BA0A0621538
 * name flash-auto
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-auto.svg
 * tags
 */
export const FlashAutoIcon = createSvgIcon(<><path d="M16.85,7.65L18,4L19.15,7.65M19,2H17L13.8,11H15.7L16.4,9H19.6L20.3,11H22.2M3,2V14H6V23L13,11H9L13,2H3Z" /></>, 'FlashAutoIcon');
export default FlashAutoIcon